/************************************************************************
6/19/17
All Actions for timesheet, auth interactions
************************************************************************/
import { FETCH_LEVEL_EMPLOYEES, FETCH_EMPLOYEE_TO_EDIT, SUBMIT_EDIT_PROFILE, CREATE_EMPLOYEE_PROFILE,
  FETCH_EMPLOYEE_PROFILE, FETCH_POSITION_TYPE, CREATE_LOGIN_PROFILE, SUBMIT_EDIT_LOGIN, DOWNLOAD_EMPLOYEES
} from './types';
import { error } from './index';
import { ROOT_URL } from '../constants';
import { fillEdit, clearForm, findEmployeeByName } from '../utils';
import moment from 'moment';
import axios from 'axios';
const Materialize = window.Materialize;
const $ = window.$;
const FileSaver = require('file-saver');
/****************************  ASYNCHRONOUS Actions ***************************/
/*
  Fetch all employees based on level and email;
  If the level is 1, only fetch the employee
  If level is 2; fetch only their employees
  If level is 3 or greater, fetch all employees
*/
export function fetchAllEmployees(level, email, eid) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchAllEmployees`, {
      params: { level, email, eid },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        dispatch({ type: FETCH_LEVEL_EMPLOYEES, payload: res.employees });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching all employees`));
      });
  }
}

/* Submits a profile to create a new employee */
export function submitProfileToCreate(profile, employees) {
  if (!(profile.firstName && profile.lastName)) return error('Please enter a first name and last name.');
  $('#preloader').css('display','block');
  if (document.getElementById('create-profile-partTime').checked) profile.partTime = 1;
  else profile.partTime = 0;
  // Check if they selected a manager to fill in
  if (profile.managerId) {
    let manager = findEmployeeByName(profile.managerId, employees);
    profile.managerId = manager.eid;
  }

  // Make sure unique eid
  if (employees.find((e) => e.eid === profile.eid)) return error('Employee ID already exists');
  clearForm('profile-create-form');

  return (dispatch) => {
    axios.post(`${ROOT_URL}/submitProfileToCreate`, { profile })
      .then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.msg, 4000, 'green rounded');
        dispatch({ type: CREATE_EMPLOYEE_PROFILE, payload: res.employees });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error creating a user profile`));
      });
  }
}

/* Submits a profile to create a new employee login */
export function submitProfileForLogin(profile, employees) {
  if (profile.password !== profile.passwordVerify) return error('Passwords must match');
  if (!(profile.email && profile.eid && profile.level)) return error('Email, Employee ID and Access Level required');
  $('#preloader').css('display','block');

  clearForm('profile-createAuth-form');

  return (dispatch) => {
    axios.post(`${ROOT_URL}/submitProfileForLogin`, { profile })
      .then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        if (res.error) error(res.error);
        Materialize.toast(res.msg, 4000, 'green rounded');
        dispatch({ type: CREATE_LOGIN_PROFILE });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(err));
      });
  }
}

/* Submits a profile for editing */
export function submitProfileToEdit(profile, employees, employee) {
  if (!(profile.firstName && profile.lastName && profile.eid)) return error('Please enter a first name, last name, employee id.');
  $('#preloader').css('display','block');
  if (document.getElementById('edit-profile-partTime').checked) profile.partTime = 1;
  else profile.partTime = 0;
  let manager = findEmployeeByName(profile.managerId, employees);
  if (manager) profile.managerId = manager.eid;

  clearForm('profile-edit-form');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/submitProfileToEdit`, { profile, employee })
      .then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.msg, 4000, 'green rounded');
        dispatch({ type: SUBMIT_EDIT_PROFILE, payload: res.employees });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error editing the profile ${err}`));
      });
  }
}

/* Submits a profile for editing */
export function submitLoginToEdit(profile, employee) {
  if (!(profile.email && profile.eid && profile.level)) return error('Email, Employee ID and Access Level required');
  if (profile.password !== profile.passwordVerify) return error('Passwords must match');
  $('#preloader').css('display','block');

  clearForm('profile-editAuth-form');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/submitLoginToEdit`, { profile, employee })
      .then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        Materialize.toast(res.msg, 4000, 'green rounded');
        dispatch({ type: SUBMIT_EDIT_LOGIN, payload: res.employees });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error editing the profile ${err}`));
      });
  }
}

/* Fetches an employee profile from button clicks */
export function fetchEmployeeProfile(employee) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchEmployeeProfile`, {
      params: { employee },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        dispatch({type: FETCH_EMPLOYEE_PROFILE, payload: res.profile});
      }).catch((err) => {
        $('#preloader').css('display','none');
        console.error(err)
        dispatch(error(`There was an error fetching employee information`));
      });
  }
}
/* Fetches an employee profile from autocomplete name selection */
export function fetchEmployeeProfileByName(emp) {
  if (!emp) return error('Please enter an employees name');
  document.getElementById('employee-profile-list').value = '';
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchEmployeeProfile`, {
      params: { employee: emp },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        dispatch({type: FETCH_EMPLOYEE_PROFILE, payload: res.profile});
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching employee information`));
      });
  }
}
/* Fetches position types */
export function fetchPostionType() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchPostionType`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        //console.log(res);
        dispatch({type: FETCH_POSITION_TYPE, payload: res.positionTypes });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching position types`));
      });
  }
}

/* Fetches position types */
export function downloadEmployees() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/downloadEmployees`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        var blob = new Blob([res.csv], {type: "text/plain;charset=utf-8"});
        FileSaver.saveAs(blob, `Current Employee List ${moment().format('YYYY-MM-DD')}.csv`);
        dispatch({ type: DOWNLOAD_EMPLOYEES });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching position types`));
      });
  }
}

/*******************************************************************
Specific for Image uploads
********************************************************************/
export function uploadProfileImage(eid) {
  if (!eid) return error('Please select an employee prior to uploading a picture');
  $('#preloader').css('display','block');
  let data = new FormData();
  let file = document.getElementById('employee-profile-img').files[0];
  data.append('imgUploader', file, file.name);

  return (dispatch) => {
    axios.post(`${ROOT_URL}/uploadProfileImage`, data, {
      params: { eid },
      headers: { 'content-type': 'multipart/form-data' }
    }).then((res) => {
      $('#preloader').css('display','none');
      Materialize.toast('Successfully uploaded an image', 4000, 'rounded green');
      document.getElementById('file-path').value = '';
      dispatch({type: 'DUMMY'});
    }).catch((err) => {
      $('#preloader').css('display','none');
      dispatch(error(`There was an error uploading a profile image`));
    });
  }
}

/****************************  SYNCHRONOUS Actions ***************************/

/* Fetches an employee profile locally as all profiles are stored in memory */
export function fetchProfileToEdit(e, employees) {
  let manager;
  if (typeof e === 'object') { // User clicked on employee button
    // Get manager name
    manager = employees.find((emp) => emp.eid === e.managerId);
    fillEdit('profile-edit-form', e);
    fillEdit('profile-editAuth-form', e);
    if (manager !== undefined) {
      document.getElementById('edit-profile-managerId').value = `${manager.firstName} ${manager.lastName}`;
    }
    document.getElementById('employee-profile-list').value = '';
    return {
      type: FETCH_EMPLOYEE_TO_EDIT,
      payload: e
    };
  } else { // User is searching for employees by AutoComplete
    document.getElementById('employee-profile-list').value = '';
    manager = employees.find((emp) => emp.eid === e.managerId);
    fillEdit('profile-edit-form', e);
    fillEdit('profile-editAuth-form', e);
    if (manager !== undefined) {
      document.getElementById('edit-profile-managerId').value = `${manager.firstName} ${manager.lastName}`;
    }
    return {
      type: FETCH_EMPLOYEE_TO_EDIT,
      payload: e
    };
  }
}



/* */

/* END */



// WEBPACK FOOTER //
// ./src/actions/profile_actions.js